import React, { useState, useEffect ,useLayoutEffect} from 'react';
import { Button } from "../atoms/button";
import useMedia from 'use-media';
import { useRtoaster } from '../../hooks/useRtoaster';
import { connect,useStore } from "react-redux";
import image_base from '../../resources/image/GrandeeHamanako2.jpg';
import { Link, useHistory } from "react-router-dom";
import { InputForm } from '../molecules/inputForm';
import { Inputheader } from "../molecules/inputheader";
import { ReserverInputheader } from "../molecules/reserverInputheader";
import { Label } from '../atoms/label';
import { Line } from '../atoms/line';
import { PullDown } from '../atoms/pullDown';
import { BlackCheckBox } from '../atoms/blackCheckBox';
import { TextArea } from "../atoms/textArea";
import { GolfFooterContainer } from "../organisms/golfFooterContainer";
import img_pull from '../../resources/icons/arw_pulldown.svg';
import common from "../../resources/js/common/common"
import constant from "../../const/Const";
import { versionGetApi } from '../../const';
import { apiKeyCheck } from '../../const';
import commonUtil from '../../common/commonUtil';

const GolfInputContainer = (props) => {
    const { 
        inputPlayer,
        teeTimeList, 
        reserver, 
        addInputPlayer, 
        addTeeTimeList, 
        addReserver,
        login,
        changeReserveNo,
        kaiinken,
        course,
        reserveCheckInfo,
        plan,
        facility,
        state,
        golfLocation
    } = props;

    const store = useStore();

    const [disabled, setDisabled] = useState(false);
    // 空文字チェック
    const [emptyChecked, setEmptyChecked] = useState(false);
    // 代表者名不整合チェック
    const [unmatchChecked, setUnmatchChecked] = useState(false);
    // バイト数チェック
    const [bytesChecked, setBytesChecked] = useState(false);
    // 文字列数チェック
    const [strLenChecked, setStrLenChecked] = useState(false);
    // 全角カナチェック
    const [kanaChecked, setKanaChecked] = useState(false);
    // メールアドレスフォーマットチェック
    const [emailFormatChecked, setEmailFormatChecked] = useState(false);
    // 電話番号フォーマットチェック
    const [phoneFormatChecked, setPhoneFormatChcked] = useState(false);

    const [reserverSurnameKanji, setReserverSurnameKanji] = useState("");
    const [reserverNameKanji, setReserverNameKanji] = useState("");
    const [reserverSurnameKana, setReserverSurnameKana] = useState("");
    const [reserverNameKana, setReserverNameKana] = useState("");
    const [genderVal, setGenderVal] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [prefecture, setPrefecture] = useState("");
    const [remarks, setRemarks] = useState("");

    const [courseName, setCourseName] = useState("");
    const [planDate, setPlanDate] = useState("");

    console.log(inputPlayer);

    const gender = [
        {value: "0", option: "男性"},
        {value: "1", option: "女性"},
        {value: "9", option: "その他"},
    ];

    const prefectures = [
        {value:"0",option:"北海道"},
        {value:"1",option:"青森県"},
        {value:"2",option:"岩手県"},
        {value:"3",option:"宮城県"},
        {value:"4",option:"秋田県"},
        {value:"5",option:"山形県"},
        {value:"6",option:"福島県"},
        {value:"7",option:"茨城県"},
        {value:"8",option:"栃木県"},
        {value:"9",option:"群馬県"},
        {value:"10",option:"埼玉県"},
        {value:"11",option:"千葉県"},
        {value:"12",option:"東京都"},
        {value:"13",option:"神奈川県"},
        {value:"14",option:"新潟県",selected:"true"},
        {value:"15",option:"富山県"},
        {value:"16",option:"石川県"},
        {value:"17",option:"福井県"},
        {value:"18",option:"山梨県"},
        {value:"19",option:"長野県"},
        {value:"20",option:"岐阜県"},
        {value:"21",option:"静岡県"},
        {value:"22",option:"愛知県"},
        {value:"23",option:"三重県"},
        {value:"24",option:"滋賀県"},
        {value:"25",option:"京都府"},
        {value:"26",option:"大阪府"},
        {value:"27",option:"兵庫県"},
        {value:"28",option:"奈良県"},
        {value:"29",option:"和歌山県"},
        {value:"30",option:"鳥取県"},
        {value:"31",option:"島根県"},
        {value:"32",option:"岡山県"},
        {value:"33",option:"広島県"},
        {value:"34",option:"山口県"},
        {value:"35",option:"徳島県"},
        {value:"36",option:"香川県"},
        {value:"37",option:"愛媛県"},
        {value:"38",option:"高知県"},
        {value:"39",option:"福岡県"},
        {value:"40",option:"佐賀県"},
        {value:"41",option:"長崎県"},
        {value:"42",option:"熊本県"},
        {value:"43",option:"大分県"},
        {value:"44",option:"宮崎県"},
        {value:"45",option:"鹿児島県"},
        {value:"46",option:"沖縄県"}
    ]

    const history = useHistory();

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);

    // rtoasterタグ生成
    let customParam = {};
    if (reserveCheckInfo.length !== 0) {
        let jsonTxt = reserveCheckInfo.reservationsDayInformationList[0].ntgGeneralPurposeItem;
        let jsonObj = JSON.parse(jsonTxt);
        const contractNo = jsonObj.ResortTrustInfomation.ownerMemberCode;
        const riyoDate = new Date(reserveCheckInfo.playDate);
        const facilityCd = course?.length ? course.find(value => value.id == reserveCheckInfo.golfCourseID)?.facilityCd : "";

        customParam = {
            "sisetucd": facilityCd,
            "riyodat": `${riyoDate.getFullYear()}-${(riyoDate.getMonth() + 1).toString().padStart(2, "0")}-${(riyoDate.getDate()).toString().padStart(2, "0")}`,
            "keiyakuno": contractNo,
            "packcd": plan.planid,
            "packnam": plan.planname,
            "coursecd": teeTimeList?.map(value => { return value.courseID })?.join(","),
            "startjikan": teeTimeList?.map(value => { return value.teeTime })?.join(","),
        }
    } else {
        const riyoDate = new Date(plan?.plansets?.[0]?.playdates?.[0]?.playdate?.substr(0, 10));
        let contractNo = "";
        kaiinken.forEach((data) => {
            if (data.selected === true) {
                contractNo = data.contractNo;
            }
        });
        customParam = {
            "sisetucd": course.find(value => value.id == plan.golfCourseID)?.facilityCd,
            "riyodat": riyoDate ? `${riyoDate.getFullYear()}-${(riyoDate.getMonth() + 1).toString().padStart(2, "0")}-${(riyoDate.getDate()).toString().padStart(2, "0")}` : "",
            "keiyakuno": contractNo,
            "packcd": plan.planid,
            "packnam": plan.planname,
            "coursecd": teeTimeList?.map(value => { return value.courseID })?.join(","),
            "startjikan": teeTimeList?.map(value => { return value.teeTime })?.join(","),
        }
    }
    useRtoaster(history.location.pathname, customParam);

    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if(Object.keys(state).length !== 0){   
            apiKey = state.apiKey;
        }
        if(apiKey === null){
            store.dispatch({ type: "CLEAR_STATE"});
            history.push("/reserve/login");
        }
        if(apiKey){
        common.doPost(apiKeyCheck, {apikey:apiKey}, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if(!res.data){
            store.dispatch({ type: "CLEAR_STATE"});
            history.push("/reserve/login");
        }
    }

    // 初期表示
    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);

        const loginUserInfo = store.getState().login.loginUserInfo;

        //予約変更の場合の自動入力
        if(reserveCheckInfo !== undefined && reserveCheckInfo !== "" && reserveCheckInfo.length !== 0){
            setReserverSurnameKanji(reserveCheckInfo.familyName);
            setReserverNameKanji(reserveCheckInfo.firstName);
            setReserverSurnameKana(reserveCheckInfo.familyNameKana);
            setReserverNameKana(reserveCheckInfo.firstNameKana);
            setEmailAddress(reserveCheckInfo.email);
            setRemarks(reserveCheckInfo.remark);
            setPhoneNumber(reserveCheckInfo.contactPhoneNumber);
            if(reserver.gender == undefined || reserver.gender == null){
                let gender = reserveGender();
                let genderElm = document.getElementById("reserver_gender_type");
                let genderOption = genderElm.options;
                genderOption[gender].selected = true;
            }
            //都道府県
            if(reserver.prefecture == null || reserver.prefecture == undefined){
                const filtered = prefectures.filter((item)=>{return item.option === reserveCheckInfo.addressPref});
                console.log(filtered);
                let elem = document.getElementById("reserver_prefecture");
                let option = elem.options;
                if(filtered !== null && filtered !== undefined && filtered.length !== 0){
                    option[filtered[0].value].selected = true;
                }
            }

            // setPrefecture(filtered[0].value);
        }
        else if(loginUserInfo){

            // 姓(漢字)
            setReserverSurnameKanji(loginUserInfo.memberSei ? loginUserInfo.memberSei : "");
            // 名(漢字)
            setReserverNameKanji(loginUserInfo.memberMei ? loginUserInfo.memberMei : "");
            // セイ(カナ)
            setReserverSurnameKana(loginUserInfo.memberSeiKana ? loginUserInfo.memberSeiKana : "");
            // メイ(カナ)
            setReserverNameKana(loginUserInfo.memberMeiKana ? loginUserInfo.memberMeiKana : "");
            // 性別
            if(loginUserInfo.sexCode === "01"){
                setGenderVal(0);
            }
            else if(loginUserInfo.sexCode === "02"){
                setGenderVal(1);
            }
            else {
                setGenderVal(9);
            }
            // 予約連絡先メールアドレス
            if(loginUserInfo.mobileAddress){
                setEmailAddress(loginUserInfo.mobileAddress);
            }
            else if(loginUserInfo.pcAddress){
                setEmailAddress(loginUserInfo.pcAddress);
            }

            // 予約連絡先電話番号
            if(loginUserInfo.mobilePhone){
                var phoneStr = loginUserInfo.mobilePhone;
                var mobileResult = phoneStr.replace("-", "");
                while(mobileResult !== phoneStr) {
                    phoneStr = phoneStr.replace("-", "");
                    mobileResult = mobileResult.replace("-", "");
                }
                setPhoneNumber(mobileResult);
            }
            else if(loginUserInfo.phone){
                var phoneStr2 = loginUserInfo.phone;
                var phoneResult = phoneStr2.replace("-", "");
                while(phoneResult !== phoneStr2) {
                    phoneStr2 = phoneStr2.replace("-", "");
                    phoneResult = phoneResult.replace("-", "");
                }
                setPhoneNumber(phoneResult);
            }
            // 都道府県
            if(reserver.prefecture == null || reserver.prefecture == undefined){
                if(loginUserInfo.address1){
                    const filtered = prefectures.filter((item)=>{return item.option === loginUserInfo.address1})
                    let elem = document.getElementById("reserver_prefecture");
                    let option = elem.options;
                    console.log("フィルター後");
                    console.log(filtered);
                    if(filtered !== undefined && filtered !== null && filtered.length !== 0){
                        option[filtered[0].value].selected = true;
                    }else{
                        option[0].selected = true;
                    }
                    // setPrefecture(filtered[0].value);
                }
            }
            //性別
            if(reserver.gender == undefined || reserver.gender == null){
                let gender = 0;
                if(loginUserInfo.sexCode === "01"){
                    gender = 0;
                }else if(loginUserInfo.sexCode === "02"){
                    gender = 1;
                }else {
                    gender = 2;
                }
                let genderElm = document.getElementById("reserver_gender_type");
                let genderOption = genderElm.options;
                genderOption[gender].selected = true;
            }
        }

        const checkedelemRepre = document.getElementsByClassName("undecidedCheckedRepre");

        for (let idxRepre = 0; idxRepre < checkedelemRepre.length; idxRepre++) {

            let id = parseInt((checkedelemRepre[idxRepre].id)-99).toString();
            let checked = checkedelemRepre[idxRepre].checked;
            let element = null;

            if (checked) {
                element = document.getElementById(`representSurnameKanji${id}`);
                element.disabled = true;
    
                element = document.getElementById(`representNameKanji${id}`);
                element.disabled = true;
    
                element = document.getElementById(`representSurnameKana${id}`);
                element.disabled = true;
    
                element = document.getElementById(`representNameKana${id}`);
                element.disabled = true;
    
                element = document.getElementById(`represent_gender_type${id}`);
                element.disabled = true;
            } else {
                element = document.getElementById(`representSurnameKanji${id}`);
                element.disabled = false;
    
                element = document.getElementById(`representNameKanji${id}`);
                element.disabled = false;
    
                element = document.getElementById(`representSurnameKana${id}`);
                element.disabled = false;
    
                element = document.getElementById(`representNameKana${id}`);
                element.disabled = false;
    
                element = document.getElementById(`represent_gender_type${id}`);
                element.disabled = false;
            }
        }

        const checkedelem = document.getElementsByClassName("undecidedChecked");

        for (let i = 0; i < checkedelem.length; i++) {

            let id = checkedelem[i].id;
            let checked = checkedelem[i].checked;
            let element = null;

            if (checked) {
                element = document.getElementById(`accompanySurnameKanji${id}`);
                element.disabled = true;
    
                element = document.getElementById(`accompanyNameKanji${id}`);
                element.disabled = true;
    
                element = document.getElementById(`accompanySurnameKana${id}`);
                element.disabled = true;
    
                element = document.getElementById(`accompanyNameKana${id}`);
                element.disabled = true;
    
                element = document.getElementById(`gender_type${id}`);
                element.disabled = true;
            } else {
                element = document.getElementById(`accompanySurnameKanji${id}`);
                element.disabled = false;
    
                element = document.getElementById(`accompanyNameKanji${id}`);
                element.disabled = false;
    
                element = document.getElementById(`accompanySurnameKana${id}`);
                element.disabled = false;
    
                element = document.getElementById(`accompanyNameKana${id}`);
                element.disabled = false;
    
                element = document.getElementById(`gender_type${id}`);
                element.disabled = false;
            }
        }
        if(reserveCheckInfo === undefined || reserveCheckInfo === "" || reserveCheckInfo.length === 0){
            let ownerCheckelement = document.getElementById(`reserver_owner_checked`);
            if(reserver.ownerCheck === true){
                ownerCheckelement.checked = true;
            }else if(reserver.ownerCheck === false){
                ownerCheckelement.checked = false;
            }else{
                ownerCheckelement.checked = true;
            }
        }
        const elements = document.getElementsByClassName("representChecked");
        let checkId = "";
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].checked) {
                checkId = elements[i].id;
            }
        }
        if(checkId !== ""){
            for (let i = 0; i < elements.length; i++) {
                if (elements[i].id !== checkId) {
                    elements[i].disabled = true;
                }
            }
        }
        common.scrollWindowTop();
        setPlanInfo();
    }, []);

    //ゴルフ場名と日付を表示ステートに詰める
    const setPlanInfo = () => {
        //予約確認からの場合
        if(reserveCheckInfo !== undefined && reserveCheckInfo !== null && reserveCheckInfo.length !== 0){
            setCourseName("ゴルフ場：" + reserveCheckInfo.golfCourseName);
            setPlanDate("プレー日：" + commonUtil.getStringFromDateJpnGolf(reserveCheckInfo.playDate.substr(0, 10)));
        }else{  /* 正規予約の場合 */
            if(facility){
                setCourseName("ゴルフ場：" + facility.name);
            }
            if(plan && plan.plansets && plan.plansets[0].playdates){
                setPlanDate("プレー日：" + commonUtil.getStringFromDateJpnGolf(plan.plansets[0].playdates[0].playdate.substr(0, 10)));
            }
        }
    }
    const dateForm = (res) => {
        let date = res.substr(0, 4) + "年";
        if (res.substr(5, 1) === '0') {
            date = date + res.substr(6, 1) + "月";
        } else {
            date = date + res.substr(5, 2) + "月";
        }

        if (res.substr(8, 1) === '0') {
            date = date + res.substr(9, 1) + "日";
        } else {
            date = date + res.substr(8, 2) + "日";
        }
        return date;
    }

    //予約変更時代表者性別取得
    const reserveGender = () => {
        //初期値男性
        let gender = 0;
        if(reserveCheckInfo.teeTimeList !== undefined && reserveCheckInfo.teeTimeList !== null && reserveCheckInfo.teeTimeList.length !== 0){
            reserveCheckInfo.teeTimeList.map((data) => {
                if(data.playerList !== undefined && data.playerList !== null && data.playerList.length !== 0){
                    data.playerList.map((user) => {
                        if(user.webUserFlag === 1){
                            switch(user.genderType){
                                case 1:
                                    gender = 1
                                    break;
                                case 9:
                                    gender = 2
                                    break;
                            }
                        }
                    })
                }
            })
        }
        return gender;
    };

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if(flg){
            history.push("/reserve/login");
            return;
        }
    }

    const onClickBack = () => {
        if(changeReserveNo !== undefined && changeReserveNo !== null && changeReserveNo !== ""){

            if(golfLocation === "input"){
                history.push("/reserve/golf/bookingConfirmDetaile");
            }else{
                history.push("/reserve/golf/changeStartTime");
            }
        }else{
            history.push("/reserve/golf/startTime");
        }
    };

    // 空文字チェック
    const checkEmpty = (value) => {
        if (value === "") {
            return true;
        } else {
            return false;
        }
    }

    // バイト数チェック(30バイト全角10文字)
    const checkBytes = (value) => {
        let len = encodeURI(value).replace(/%../g, "*").length;
        if (len > 30) {
            return true;
        } else {
            return false;
        }
    }

    // 文字列数チェック(メールアドレス)
    const checkStrLen = (value) => {
        if (value.length > 256) {
            return true;
        } else {
            return false;
        }
    }

    // 全角カナチェック
    const checkKana = (value) => {
        let reg = new RegExp("^[ァ-ヴ]*$");
        if (!reg.test(value)) {
            return true;
        } else {
            return false;
        }
    }

    // メールアドレスフォーマットチェック
    const checkEmailFormat = (value) => {
        let reg = new RegExp("^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}.[A-Za-z0-9]{1,}$");
        if (!reg.test(value)) {
            return true;
        } else {
            return false;
        }
    }

    // 電話番号フォーマットチェック
    const checkPhoneFormat = (value) => {
        let reg = new RegExp("^[0-9]*$", "g");
        if (!reg.test(value)) {
            return true;
        } else {
            return false;
        }
    }

    const htmlsanitize = (str) => {
        return String(str).replace(/&/g,"&amp;")
          .replace(/</g,"&lt;")
          .replace(/>/g,"&gt;")
          .replace(/"/g,"&quot;")
    }

    // 代表者チェックボックス押下時
    const onChangeRepresent = (e) => {
        
        const id = e.target.id
        const checked = e.target.checked;
        let element = null;

        if (checked) {
            // 予約者
            const reserverSurnameKanji = document.getElementById("reserverSurnameKanji");
            const reserverNameKanji = document.getElementById("reserverNameKanji");
            const reserverSurnameKana = document.getElementById("reserverSurnameKana");
            const reserverNameKana = document.getElementById("reserverNameKana");
            const gender = document.getElementById("reserver_gender_type");

            element = document.getElementsByClassName(`representSurnameKanji${id}`);
            element[0].value = reserverSurnameKanji.value;

            element = document.getElementsByClassName(`representNameKanji${id}`);
            element[0].value = reserverNameKanji.value;

            element = document.getElementsByClassName(`representSurnameKana${id}`);
            element[0].value = reserverSurnameKana.value;

            element = document.getElementsByClassName(`representNameKana${id}`);
            element[0].value = reserverNameKana.value;

            element = document.getElementsByClassName(`represent_gender_type${id}`);
            element[0].value = gender.value;

            const elements = document.getElementsByClassName("representChecked");
            for (let i = 0; i < elements.length; i++) {
                if (elements[i].id !== id) {
                    elements[i].disabled = true;
                }
            }
        } else {
            element = document.getElementsByClassName(`representSurnameKanji${id}`);
            element[0].value = "";

            element = document.getElementsByClassName(`representNameKanji${id}`);
            element[0].value = "";

            element = document.getElementsByClassName(`representSurnameKana${id}`);
            element[0].value = "";

            element = document.getElementsByClassName(`representNameKana${id}`);
            element[0].value = "";

            element = document.getElementsByClassName(`represent_gender_type${id}`);
            element[0].value = "0";

            const elements = document.getElementsByClassName("representChecked");
            for (let i = 0; i < elements.length; i++) {
                if (elements[i].id !== id) {
                    elements[i].disabled = false;
                }
            }
        }
    }

    // 未定チェックボックス押下時
    const onChangeInactive = (e) => {

        const id = e.target.id;
        const checked = e.target.checked;
        let element = null;

        if (checked) {
            element = document.getElementById(`accompanySurnameKanji${id}`);
            element.disabled = true;
            element.style.backgroundColor = "";

            element = document.getElementById(`accompanyNameKanji${id}`);
            element.disabled = true;
            element.style.backgroundColor = "";

            element = document.getElementById(`accompanySurnameKana${id}`);
            element.disabled = true;
            element.style.backgroundColor = "";

            element = document.getElementById(`accompanyNameKana${id}`);
            element.disabled = true;
            element.style.backgroundColor = "";

            element = document.getElementById(`gender_type${id}`);
            element.disabled = true;
        } else {
            element = document.getElementById(`accompanySurnameKanji${id}`);
            element.disabled = false;

            element = document.getElementById(`accompanyNameKanji${id}`);
            element.disabled = false;

            element = document.getElementById(`accompanySurnameKana${id}`);
            element.disabled = false;

            element = document.getElementById(`accompanyNameKana${id}`);
            element.disabled = false;

            element = document.getElementById(`gender_type${id}`);
            element.disabled = false;
        }
        
        // setDisabled(!disabled);
    }

    // 未定チェックボックス(1組目)押下時
    const onChangeInactiveRepre = (e) => {

        const id = parseInt((e.target.id)-99).toString();
        const checked = e.target.checked;
        let element = null;

        if (checked) {
            element = document.getElementById(`representSurnameKanji${id}`);
            element.disabled = true;
            element.style.backgroundColor = "";

            element = document.getElementById(`representNameKanji${id}`);
            element.disabled = true;
            element.style.backgroundColor = "";

            element = document.getElementById(`representSurnameKana${id}`);
            element.disabled = true;
            element.style.backgroundColor = "";

            element = document.getElementById(`representNameKana${id}`);
            element.disabled = true;
            element.style.backgroundColor = "";

            element = document.getElementById(`represent_gender_type${id}`);
            element.disabled = true;
        } else {
            element = document.getElementById(`representSurnameKanji${id}`);
            element.disabled = false;

            element = document.getElementById(`representNameKanji${id}`);
            element.disabled = false;

            element = document.getElementById(`representSurnameKana${id}`);
            element.disabled = false;

            element = document.getElementById(`representNameKana${id}`);
            element.disabled = false;

            element = document.getElementById(`represent_gender_type${id}`);
            element.disabled = false;
        }
        
        // setDisabled(!disabled);
    }

    const determination = () => {

        // 利用者1バイト数チェック
        let representFullNameBytes = false;
        let representFullNameKanaBytes = false;
        // 利用者2以降バイト数チェック
        let accompanyFullNameBytes = false;
        let accompanyFullNameKanaBytes = false;
        // 利用者1カナチェック
        let representSurnameKanaChecked = false;
        let representNameKanaChecked = false;
        // 利用者2以降カナチェック
        let accompanySurnameKanaCheeked = false;
        let accompanyNameKanaChecked = false;
        // 利用者1空文字チェック
        let representSurnameKanjiEmpty = false;
        let representNameKanjiEmpty = false;
        let representSurnameKanaEmpty = false;
        let representNameKanaEmpty = false;
        // 利用者2以降空文字チェック
        let accompanySurnameKanjiEmpty = false;
        let accompanyNameKanjiEmpty = false;
        let accompanySurnameKanaEmpty = false;
        let accompanyNameKanaEmpty = false;

        // 利用代表者
        const reserverSurnameKanji = document.getElementById("reserverSurnameKanji");
        const reserverNameKanji = document.getElementById("reserverNameKanji");
        const reserverSurnameKana = document.getElementById("reserverSurnameKana");
        const reserverNameKana = document.getElementById("reserverNameKana");
        const emailAddress = document.getElementById("email_address");
        const phoneNumber = document.getElementById("phone_number");
        const gender = document.getElementById("reserver_gender_type");
        const remark = document.getElementById("reserver_note");
        const prefecture = document.getElementById("reserver_prefecture");
        const ownerCheck = document.getElementById("reserver_owner_checked");

        // 利用代表者不整合チェック
        let representSurnameKanjiUnmatch = false;
        let representNameKanjiUnmatch = false;
        let representSurnameKanaUnmatch = false;
        let representNameKanaUnmatch = false;
        let representSexUnmatch = false;

        // DOMリセット
        reserverSurnameKanji.style.backgroundColor = "";
        reserverNameKanji.style.backgroundColor = "";
        reserverSurnameKana.style.backgroundColor = "";
        reserverNameKana.style.backgroundColor = "";
        emailAddress.style.backgroundColor = "";
        phoneNumber.style.backgroundColor = "";
        gender.style.backgroundColor = "";

        // 空文字チェック
        let emptyFlag = false;
        let unmatchFlag = false;
        let flg1 = checkEmpty(reserverSurnameKanji.value);
        if (flg1 === true) reserverSurnameKanji.style.backgroundColor = constant.ERROR_COLOR;
        let flg2 = checkEmpty(reserverNameKanji.value);
        if (flg2 === true) reserverNameKanji.style.backgroundColor = constant.ERROR_COLOR;
        let flg3 = checkEmpty(reserverSurnameKana.value);
        if (flg3 === true) reserverSurnameKana.style.backgroundColor = constant.ERROR_COLOR;
        let flg4 = checkEmpty(reserverNameKana.value);
        if (flg4 === true) reserverNameKana.style.backgroundColor = constant.ERROR_COLOR;
        let flg5 = checkEmpty(emailAddress.value);
        if (flg5 === true) emailAddress.style.backgroundColor = constant.ERROR_COLOR;
        let flg6 = checkEmpty(phoneNumber.value);
        if (flg6 === true) phoneNumber.style.backgroundColor = constant.ERROR_COLOR;

        // バイト数チェック
        let bytesFlag = false;
        let flg7 = checkBytes(reserverSurnameKanji.value + reserverNameKanji.value);
        if (flg7 === true) {
            reserverSurnameKanji.style.backgroundColor = constant.ERROR_COLOR;
            reserverNameKanji.style.backgroundColor = constant.ERROR_COLOR;
        }
        let flg8 = checkBytes(reserverSurnameKana.value + reserverNameKana.value);
        if (flg8 === true) {
            reserverSurnameKana.style.backgroundColor = constant.ERROR_COLOR;
            reserverNameKana.style.backgroundColor = constant.ERROR_COLOR;
        }

        // 文字列数チェック
        let strLenFlag = false;
        strLenFlag = checkStrLen(emailAddress.value);
        if (strLenFlag === true) emailAddress.style.backgroundColor = constant.ERROR_COLOR;
        setStrLenChecked(strLenFlag);

        // 全角カナチェック
        let kanaFlag = false;
        let flg9 = checkKana(reserverSurnameKana.value);
        let flg10 = checkKana(reserverNameKana.value);
        if (flg9 === true) reserverSurnameKana.style.backgroundColor = constant.ERROR_COLOR;
        if (flg10 === true) reserverNameKana.style.backgroundColor = constant.ERROR_COLOR;

        // メールアドレスフォーマットチェック
        let emailFormatFlag = false;
        if (flg5 === false) {
            emailFormatFlag = checkEmailFormat(emailAddress.value);
            if (emailFormatFlag === true) emailAddress.style.backgroundColor = constant.ERROR_COLOR;
            setEmailFormatChecked(emailFormatFlag);
        }

        // 電話番号フォーマットチェック
        let phoneFormatFlag = false;
        phoneFormatFlag = checkPhoneFormat(phoneNumber.value);
        if (phoneFormatFlag === true) phoneNumber.style.backgroundColor = constant.ERROR_COLOR;
        setPhoneFormatChcked(phoneFormatFlag);

        const reserver = {
            familyName: htmlsanitize(reserverSurnameKanji.value),
            firstName: htmlsanitize(reserverNameKanji.value),
            familyNameKana: htmlsanitize(reserverSurnameKana.value),
            firstNameKana: htmlsanitize(reserverNameKana.value),
            email: htmlsanitize(emailAddress.value),
            phoneNumber: htmlsanitize(phoneNumber.value),
            gender: gender.value,
            planRemark: htmlsanitize(remark.value),
            prefecture: htmlsanitize(prefecture.value),
            prefectureName: htmlsanitize(prefecture.childNodes[prefecture.value].label),
            ownerCheck: ownerCheck !== undefined && ownerCheck !== null ? ownerCheck.checked : false
        }

        // 利用代表者情報
        addReserver(reserver);

        let size = parseInt(teeTimeList.length);
        let tempList = [];
        let inputList = [];

        // 代表者チェックボックスの要素
        const representCheckElem = document.getElementsByClassName("representChecked");

        for (let i = 0; i < size; i++) {
            // 未定リスト
            let undecidedList = [];

            // 利用者1姓
            let representSurnameKanji = [];
            let elm1 = document.getElementsByClassName(`representSurnameKanji${i + 1}`);
            for (let j = 0; j < elm1.length; j++) {
                elm1[j].style.backgroundColor = "";
                if (checkEmpty(elm1[j].value) && !elm1[j].disabled) {
                    representSurnameKanjiEmpty = true;
                    elm1[j].style.backgroundColor = constant.ERROR_COLOR;
                }
                // 代表者チェックONの時
                if(representCheckElem[i].checked &&
                    reserverSurnameKanji.value !== elm1[j].value){
                    representSurnameKanjiUnmatch = true;
                    reserverSurnameKanji.style.backgroundColor = constant.ERROR_COLOR;
                    elm1[j].style.backgroundColor = constant.ERROR_COLOR;                    
                }
                representSurnameKanji = [...representSurnameKanji, htmlsanitize(elm1[j].value)];
            }

            // 利用者1名
            let representNameKanji = [];
            let elm2 = document.getElementsByClassName(`representNameKanji${i + 1}`);
            for (let j = 0; j < elm2.length; j++) {
                elm2[j].style.backgroundColor = "";
                if (checkEmpty(elm2[j].value) && !elm2[j].disabled) {
                    representNameKanjiEmpty = true;
                    elm2[j].style.backgroundColor = constant.ERROR_COLOR;
                }
                // 代表者チェックONの時
                if(representCheckElem[i].checked &&
                    reserverNameKanji.value !== elm2[j].value){
                        representNameKanjiUnmatch = true;
                    reserverNameKanji.style.backgroundColor = constant.ERROR_COLOR;
                    elm2[j].style.backgroundColor = constant.ERROR_COLOR;                    
                }
                representNameKanji = [...representNameKanji, htmlsanitize(elm2[j].value)];
            }

            // 利用者1姓カナ
            let representSurnameKana = [];
            let elm3 = document.getElementsByClassName(`representSurnameKana${i + 1}`);
            for (let j = 0; j < elm3.length; j++) {
                elm3[j].style.backgroundColor = "";
                if (checkEmpty(elm3[j].value) && !elm3[j].disabled) {
                    representSurnameKanaEmpty = true;
                    elm3[j].style.backgroundColor = constant.ERROR_COLOR;
                }
                if (checkKana(elm3[j].value)) {
                    representSurnameKanaChecked = true;
                    elm3[j].style.backgroundColor = constant.ERROR_COLOR;
                }
                // 代表者チェックONの時
                if(representCheckElem[i].checked &&
                    reserverSurnameKana.value !== elm3[j].value){
                    representSurnameKanaUnmatch = true;
                    reserverSurnameKana.style.backgroundColor = constant.ERROR_COLOR;
                    elm3[j].style.backgroundColor = constant.ERROR_COLOR;                    
                }
                representSurnameKana = [...representSurnameKana, htmlsanitize(elm3[j].value)];
            }

            // 利用者1名カナ
            let representNameKana = [];
            let elm4 = document.getElementsByClassName(`representNameKana${i + 1}`);
            for (let j = 0; j < elm4.length; j++) {
                elm4[j].style.backgroundColor = "";
                if (checkEmpty(elm4[j].value) && !elm4[j].disabled) {
                    representNameKanaEmpty = true;
                    elm4[j].style.backgroundColor = constant.ERROR_COLOR;
                }
                if (checkKana(elm4[j].value)) {
                    representNameKanaChecked = true;
                    elm4[j].style.backgroundColor = constant.ERROR_COLOR;
                }
                // 代表者チェックONの時
                if(representCheckElem[i].checked &&
                    reserverNameKana.value !== elm4[j].value){
                    representNameKanaUnmatch = true;
                    reserverNameKana.style.backgroundColor = constant.ERROR_COLOR;
                    elm4[j].style.backgroundColor = constant.ERROR_COLOR;                    
                }
                representNameKana = [...representNameKana, htmlsanitize(elm4[j].value)];
            }


            // 利用者2以降姓
            let accompanySurnameKanji = [];
            let elm5 = document.getElementsByClassName(`accompanySurnameKanji${i + 1}`);
            for (let j = 0; j < elm5.length; j++) {
                elm5[j].style.backgroundColor = "";
                if (checkEmpty(elm5[j].value) && !elm5[j].disabled) {
                    accompanySurnameKanjiEmpty = true;
                    elm5[j].style.backgroundColor = constant.ERROR_COLOR;
                }
                accompanySurnameKanji = [...accompanySurnameKanji, htmlsanitize(elm5[j].value)];
            }

            // 利用者2以降名
            let accompanyNameKanji = [];
            let elm6 = document.getElementsByClassName(`accompanyNameKanji${i + 1}`);
            for (let j = 0; j < elm6.length; j++) {
                elm6[j].style.backgroundColor = "";
                if (checkEmpty(elm6[j].value) && !elm6[j].disabled) {
                    accompanyNameKanjiEmpty = true;
                    elm6[j].style.backgroundColor = constant.ERROR_COLOR;
                }
                accompanyNameKanji = [...accompanyNameKanji, htmlsanitize(elm6[j].value)];
            }

            // 利用者2以降姓カナ
            let accompanySurnameKana = [];
            let elm7 = document.getElementsByClassName(`accompanySurnameKana${i + 1}`);
            for (let j = 0; j < elm7.length; j++) {
                elm7[j].style.backgroundColor = "";
                if (checkEmpty(elm7[j].value) && !elm7[j].disabled) {
                    accompanySurnameKanaEmpty = true;
                    elm7[j].style.backgroundColor = constant.ERROR_COLOR;
                }
                if (checkKana(elm7[j].value) && !elm7[j].disabled) {
                    accompanySurnameKanaCheeked = true;
                    elm7[j].style.backgroundColor = constant.ERROR_COLOR;
                }
                accompanySurnameKana = [...accompanySurnameKana, htmlsanitize(elm7[j].value)];
            }

            // 利用者2以降名カナ
            let accompanyNameKana = [];
            let elm8 = document.getElementsByClassName(`accompanyNameKana${i + 1}`);
            for (let j = 0; j < elm8.length; j++) {
                elm8[j].style.backgroundColor = "";
                if (checkEmpty(elm8[j].value) && !elm8[j].disabled) {
                    accompanyNameKanaEmpty = true;
                    elm8[j].style.backgroundColor = constant.ERROR_COLOR;
                }
                if (checkKana(elm8[j].value) && !elm8[j].disabled) {
                    accompanyNameKanaChecked = true;
                    elm8[j].style.backgroundColor = constant.ERROR_COLOR;
                }
                accompanyNameKana = [...accompanyNameKana, htmlsanitize(elm8[j].value)];
            }

            // 姓名結合処理
            // 利用者1氏名フル
            let playerList = [];
            for (let j = 0; j < representSurnameKanji.length; j++) {
                let fullName = representSurnameKanji[j] + representNameKanji[j];
                if (elm1[j].disabled === false) {
                    if (checkBytes(fullName)) {
                        representFullNameBytes = true;
                        elm1[j].style.backgroundColor = constant.ERROR_COLOR;
                        elm2[j].style.backgroundColor = constant.ERROR_COLOR;
                    }
                    undecidedList.push(false);
                } else {
                    fullName = "";
                    undecidedList.push(true);
                }
                playerList.push(fullName);
            }

            // 姓名結合処理
            // 利用者2以降氏名フル
            for (let j = 0; j < accompanySurnameKanji.length; j++) {
                let fullName = accompanySurnameKanji[j] + accompanyNameKanji[j];
                if (elm5[j].disabled === false) {
                    if (checkBytes(fullName)) {
                        accompanyFullNameBytes = true;
                        elm5[j].style.backgroundColor = constant.ERROR_COLOR;
                        elm6[j].style.backgroundColor = constant.ERROR_COLOR;
                    }
                    undecidedList.push(false);
                } else {
                    fullName = "";
                    undecidedList.push(true);
                }
                playerList.push(fullName);
            }

             // 姓名結合処理
            // 利用者1氏名カナ_フル
            let playerKanaList = [];
            for (let j = 0; j < representSurnameKana.length; j++) {
                let fullName = representSurnameKana[j] + representNameKana[j];
                if (checkBytes(fullName)) {
                    representFullNameKanaBytes = true;
                    elm3[j].style.backgroundColor = constant.ERROR_COLOR;
                    elm4[j].style.backgroundColor = constant.ERROR_COLOR;
                }
                playerKanaList.push(fullName);
            }

            // 姓名結合処理            
            // 利用者2以降氏名カナ_フル
            for (let j = 0; j < accompanySurnameKana.length; j++) {
                let fullName = accompanySurnameKana[j] + accompanyNameKana[j];
                if (elm5[j].disabled === false) {
                    if (checkBytes(fullName)) {
                        accompanyFullNameKanaBytes = true;
                        elm7[j].style.backgroundColor = constant.ERROR_COLOR;
                        elm8[j].style.backgroundColor = constant.ERROR_COLOR;
                    }
                } else {
                    fullName = "";
                }
                playerKanaList.push(fullName);
            }

            // 性別
            let genderList = [];
            let elm9 = document.getElementsByClassName(`represent_gender_type${i + 1}`);
            for (let j = 0; j < elm9.length; j++) {
                if(representCheckElem[i].checked &&
                    gender.value !== elm9[j].value){
                    representSexUnmatch = true;
                    gender.style.backgroundColor = constant.ERROR_COLOR;
                    elm9[j].style.backgroundColor = constant.ERROR_COLOR;
                } else {
                    genderList = [...genderList, elm9[j].value];
                }
            }

            let elm10 = document.getElementsByClassName(`gender_type${i + 1}`);
            for (let j = 0; j < elm10.length; j++) {
                genderList = [...genderList, elm10[j].value];
            }

            // 代表者姓＋同伴者姓(漢字)
            const familyNameList = representSurnameKanji.concat(accompanySurnameKanji);
            // 代表者名＋同伴者名(漢字)
            const nameList = representNameKanji.concat(accompanyNameKanji);
            // 代表者姓＋同伴者姓(カナ)
            const familyNameKanaList = representSurnameKana.concat(accompanySurnameKana);
            // 代表者名＋同伴者名(カナ)
            const nameKanaList = representNameKana.concat(accompanyNameKana);

            let tempObj = {
                group: i + 1,
                familyNameList: familyNameList,
                nameList: nameList,
                familyNameKanaList: familyNameKanaList,
                nameKanaList: nameKanaList,
                undecidedList: undecidedList,
                playerList: playerList,
                playerKanaList: playerKanaList,
                genderList: genderList,
            }
            tempList.push(tempObj);
        }
        console.log(tempList);

        tempList.forEach((data, index) => {
            let inputPlayerInfoList = [];
            let playerObjectList = [];
            for (let i = 0; i < data.playerList.length; i++) {
                let flg = false;
                if(i === 0){
                    let DaihyoElement = document.getElementById(`${index+1}`);
                    console.log("代表者"+DaihyoElement.checked);
                    flg = DaihyoElement.checked;
                }
                // 入力内容保持
                const inputPlayerInfo = {
                    familyName: data.familyNameList[i],
                    name: data.nameList[i],
                    familyNameKana: data.familyNameKanaList[i],
                    nameKana: data.nameKanaList[i],
                    undecided: data.undecidedList[i],
                    represent: "",
                    gender: data.genderList[i],
                }
                // リクエスト情報(player)
                //契約番号紐づけ
                let contract = "";
                if(flg){
                    if(changeReserveNo !== undefined && changeReserveNo !== null && changeReserveNo !== ""){
                        //予約変更の場合予約情報から取得する
                        if(reserveCheckInfo.memberCode !== null && reserveCheckInfo.memberCode !== undefined && reserveCheckInfo.memberCode !== ""){
                            let jsonTxt = reserveCheckInfo.reservationsDayInformationList[0].ntgGeneralPurposeItem;
                            let jsonObj = JSON.parse(jsonTxt);
                            let contractReq = jsonObj.ResortTrustInfomation.ownerMemberCode;
                            contract = contractReq;
                        }
                    }else{
                        //新規登録の場合
                        let ownerCheckelement = document.getElementById(`reserver_owner_checked`);
                        if(ownerCheckelement.checked){
                            kaiinken.forEach((data) => {
                                if (data.selected === true) {
                                    contract = data.contractNo;
                                }
                            });
                        }
                    }
                }
                
                const playerObject = {
                    playerName:  data.undecidedList[i] ? "" : data.familyNameList[i]+" "+ data.nameList[i],
                    playerNameKana: data.undecidedList[i] ? "" : data.familyNameKanaList[i]+" "+data.nameKanaList[i],
                    genderType: data.genderList[i],
                    email: "",
                    webUserFlag: flg ? 1 : 0,
                    webUserID: "",
                    memberCode: flg ? contract : "",
                    usePoint: "",
                    zipCode: "",
                    addressPref: "",
                    address1: "",
                    address2: "",
                    address3: "",
                    phoneNumber: "",
                    contactPhoneNumber: "",
                    price: "",
                    reservationQualification: "",
                    undecided: data.undecidedList[i],
                }
                inputPlayerInfoList.push(inputPlayerInfo);
                playerObjectList.push(playerObject);
            }

            inputList.push(inputPlayerInfoList);
            teeTimeList[index].playerList = playerObjectList;
        });

        // 代表者のチェック状態保持
        inputList.forEach((data, index) => {
            data[0].represent = representCheckElem[index].checked;
        });

        // 入力情報
        addInputPlayer(inputList);
        // 枠情報
        addTeeTimeList(teeTimeList);

        emptyFlag = representSurnameKanjiEmpty || representNameKanjiEmpty || representSurnameKanaEmpty || representNameKanaEmpty || accompanySurnameKanjiEmpty || accompanyNameKanjiEmpty || accompanySurnameKanaEmpty || accompanyNameKanaEmpty || flg1 || flg2 || flg3 || flg4 || flg5 || flg6 ? true : false;
        setEmptyChecked(emptyFlag);

        unmatchFlag = representSurnameKanjiUnmatch || representNameKanjiUnmatch || representSurnameKanaUnmatch || representNameKanaUnmatch || representSexUnmatch ? true : false;
        setUnmatchChecked(unmatchFlag);

        bytesFlag = representFullNameBytes || representFullNameKanaBytes || accompanyFullNameBytes || accompanyFullNameKanaBytes || flg7 || flg8 ? true : false;
        setBytesChecked(bytesFlag);

        kanaFlag = representSurnameKanaChecked || representNameKanaChecked || accompanySurnameKanaCheeked || accompanyNameKanaChecked || flg9 || flg10 ? true : false;
        setKanaChecked(kanaFlag);

        if (emptyFlag || bytesFlag || strLenFlag || kanaFlag || emailFormatFlag || phoneFormatFlag || unmatchFlag) {
            common.scrollWindow("pagetop");
            return;
        }
        history.push("/reserve/golf/confirm");
    }

    return (
        <div style={styles.top} >
            {props.reserveType === "reserve" ? 
            <div style={isWideTablet ? styles.breadCrumb2 : styles.breadCrumb}>
                <Link to={"/reserve/top"} style={styles.link} >HOME</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/search"} style={styles.link} >ゴルフ予約</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/searchResult"} style={styles.link}>検索結果</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/startTime"} style={styles.link} >スタート時間</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Label label="利用者入力" style={styles.link} />
            </div>
            :
            <div style={isWideTablet ? styles.breadCrumb2 : styles.breadCrumb}>
                <Link to={"/reserve/top"} style={styles.link} >HOME</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/search"} style={styles.link} >ゴルフ予約</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/bookingConfirmDetaile"} style={styles.link} >予約詳細確認</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                {golfLocation === "input" ? null : <Link to={"/reserve/golf/changeStartTime"} style={styles.link} >スタート時間</Link>}
                {golfLocation === "input" ? null : <Label label=">" style={styles.breadCrumbArrow} />}
                <Label label="利用者入力" style={styles.link} />
            </div>
            }
            <div style={isWideTablet ? styles.planInfoAreaSp : styles.planInfoArea}>
                <Label label={planDate} style={isWideTablet ? styles.planInfoBodySp : styles.planInfoBody} />
                <Label label={courseName} style={isWideTablet ? styles.planInfoBodySp : styles.planInfoBody} />
            </div>
            <div id="pagetop" style={isWideTablet ? styles.base2 : styles.base}>
                <ReserverInputheader label1={"利用代表者"} />
                <div style={isWideTablet ? styles.form2 : styles.form}>
                    <div style={{ textAlign: "center", marginBottom: "20px" }}>
                        <div style={emptyChecked ? {display: "block" ,color:"red" ,textAlign:"center",fontSize:"0.8rem",background: "rgba(255,255,255,0)",border: 0,fontWeight:"bold"} : { display: "none" }}>必須項目を入力してください</div>
                        <div style={unmatchChecked ? {display: "block" ,color:"red" ,textAlign:"center",fontSize:"0.8rem",background: "rgba(255,255,255,0)",border: 0,fontWeight:"bold"} : { display: "none" }}>代表者情報が不一致です</div>
                        <div style={bytesChecked ? {display: "block" ,color:"red" ,textAlign:"center",fontSize:"0.8rem",background: "rgba(255,255,255,0)",border: 0,fontWeight:"bold"} : { display: "none" }}>姓名は全角10文字以内で入力願います</div>
                        <div style={strLenChecked ? {display: "block" ,color:"red" ,textAlign:"center",fontSize:"0.8rem",background: "rgba(255,255,255,0)",border: 0,fontWeight:"bold"} : { display: "none" }}>メールアドレスは半角256文字以内で入力願います</div>
                        <div style={kanaChecked ? {display: "block" ,color:"red" ,textAlign:"center",fontSize:"0.8rem",background: "rgba(255,255,255,0)",border: 0,fontWeight:"bold"} : { display: "none" }}>姓名(カナ)は全角カナで入力願います</div>
                        <div style={emailFormatChecked ? {display: "block" ,color:"red" ,textAlign:"center",fontSize:"0.8rem",background: "rgba(255,255,255,0)",border: 0,fontWeight:"bold"} : { display: "none" }}>メールアドレスが不正です</div>
                        <div style={phoneFormatChecked ? {display: "block" ,color:"red" ,textAlign:"center",fontSize:"0.8rem",background: "rgba(255,255,255,0)",border: 0,fontWeight:"bold"} : { display: "none" }}>電話番号はハイフンなしの数字で入力ください</div>
                    </div>
                    {changeReserveNo !== undefined && changeReserveNo !== "" ?
                        null
                        :
                        <div>
                            <BlackCheckBox 
                                id={"reserver_owner_checked"}
                                className={'reserver_owner_checked'}
                                // onChange={onChangeOwnerRepre}
                                defaultChecked={true}
                                item={"メンバー様"}
                                checkAreaStyle={{marginBottom:"10px", color: "#6f6f6f", fontSize: "small", letterSpacing: "0.2rem"}} />
                        </div>
                    }
                    <div style={{ display: "flex" }}>
                        <InputForm
                            label={"姓(漢字)"}
                            type={"text"}
                            style={isWideTablet ? styles.label2 : styles.label}
                            id={`reserverSurnameKanji`}
                            maxLength={"50"}
                            value={reserver.familyName !== undefined ? reserver.familyName : reserverSurnameKanji != undefined ? reserverSurnameKanji : ""}
                            placeholder={""}
                        />
                        <InputForm
                            label={"名(漢字)"}
                            type={"text"}
                            style={isWideTablet ? styles.label2 : styles.label}
                            id={`reserverNameKanji`}
                            maxLength={"50"}
                            value={reserver.firstName !== undefined ? reserver.firstName : reserverNameKanji != undefined ? reserverNameKanji : "" }
                            placeholder={""}
                        />
                    </div>
                    <div style={{ display: "flex" }}>
                        <InputForm
                            label={"姓(カナ)"}
                            type={"text"}
                            style={isWideTablet ? styles.label2 : styles.label}
                            id={`reserverSurnameKana`}
                            maxLength={"50"}
                            value={reserver.familyNameKana !== undefined ? reserver.familyNameKana : reserverSurnameKana != undefined ? reserverSurnameKana : ""}
                            placeholder={""}
                        />
                        <InputForm
                            label={"名(カナ)"}
                            type={"text"}
                            style={isWideTablet ? styles.label2 : styles.label}
                            id={`reserverNameKana`}
                            maxLength={"50"}
                            value={reserver.firstNameKana !== undefined ? reserver.firstNameKana : reserverNameKana != undefined ? reserverNameKana : ""}
                            placeholder={""}
                        />
                    </div>
                    <div>
                        <Label style={styles.label3} label={"性別"} />
                        <PullDown selectedValue={reserver.gender !== undefined ? reserver.gender : genderVal != undefined ? genderVal : "0"} selectStyle={styles.check} data={gender} id={`reserver_gender_type`} />
                    </div>
                    <div>
                        <Label style={styles.label3} label={"都道府県"} />
                        <PullDown selectedValue={reserver.prefecture? reserver.prefecture : prefecture != undefined ? prefecture :"0"} selectStyle={styles.check} data={prefectures} id={`reserver_prefecture`} />
                    </div>
                    <div style={{ display: "flex" }}>
                        <InputForm
                            label={"予約連絡先メールアドレス"}
                            type={"text"}
                            style={isWideTablet ? styles.label2 : styles.label}
                            id={`email_address`}
                            maxLength={"256"}
                            value={reserver.email !== undefined ? reserver.email : emailAddress != undefined ? emailAddress : ""}
                            placeholder={""}
                        />
                    </div>
                    <div style={{ display: "flex" }}>
                        <InputForm
                            label={"予約連絡先電話番号"}
                            type={"text"}
                            style={isWideTablet ? styles.label2 : styles.label}
                            id={`phone_number`}
                            maxLength={"11"}
                            value={reserver.phoneNumber !== undefined ? reserver.phoneNumber : phoneNumber != undefined ? phoneNumber : ""}
                            placeholder={""}
                        />
                    </div>
                    <div>
                        <Label style={styles.label3} label={"備考"} />
                        <TextArea style={styles.bikou} cols={60} rows={6} id={`reserver_note`} value={reserver.planRemark !== undefined ? reserver.planRemark : remarks !== undefined ? remarks : ""} />
                    </div>
                </div>
                {teeTimeList.map((data, index) => (
                    <>
                        <Inputheader label1={`${index + 1}組目`} label2={`${data.courseName}/${data.teeTime} スタート`} />
                        <div style={isWideTablet ? styles.form2 : styles.form}>
                            <div style={{marginBottom: "20px"}}>
                                <Label label={"利用者1"} style={styles.title} />
                                <BlackCheckBox 
                                    id={index + 1}
                                    className={"representChecked"}
                                    onChange={onChangeRepresent}
                                    defaultChecked={inputPlayer.length !== 0 ? inputPlayer[index][0].represent : false} 
                                    item={"代表者"} 
                                    checkAreaStyle={{color: "#6f6f6f", fontSize: "small", letterSpacing: "0.2rem"}} />
                                <BlackCheckBox 
                                        id={`${index + 100}`} 
                                        className={"undecidedCheckedRepre"}
                                        onChange={onChangeInactiveRepre} 
                                        defaultChecked={inputPlayer.length !== 0 && inputPlayer[index][0] !== undefined ? inputPlayer[index][0].undecided : false} 
                                        item={"未定"} 
                                        checkAreaStyle={{color: "#6f6f6f", fontSize: "small", letterSpacing: "0.2rem"}} />
                            </div>
                            <div style={{display: "flex"}}>
                                <InputForm
                                    label={"姓(漢字)"}
                                    type={"text"}
                                    style={isWideTablet ? styles.label2 : styles.label}
                                    class={`representSurnameKanji${index + 1}`}
                                    id={`representSurnameKanji${index + 1}`}
                                    maxLength={"50"}
                                    value={inputPlayer.length !== 0 ? inputPlayer[index][0].familyName : ""}
                                    placeholder={""}
                                    disabled={disabled}
                                />
                                <InputForm
                                    label={"名(漢字)"}
                                    type={"text"}
                                    style={isWideTablet ? styles.label2 : styles.label}
                                    class={`representNameKanji${index + 1}`}
                                    id={`representNameKanji${index + 1}`}
                                    maxLength={"50"}
                                    value={inputPlayer.length !== 0 ? inputPlayer[index][0].name : ""}
                                    placeholder={""}
                                    disabled={disabled}
                                />
                            </div>
                            <div style={{display: "flex"}}>
                                <InputForm
                                    label={"姓(カナ)"}
                                    type={"text"}
                                    style={isWideTablet ? styles.label2 : styles.label}
                                    class={`representSurnameKana${index + 1}`}
                                    id={`representSurnameKana${index + 1}`}
                                    maxLength={"50"}
                                    value={inputPlayer.length !== 0 ? inputPlayer[index][0].familyNameKana : ""}
                                    placeholder={""}
                                    disabled={disabled}
                                />
                                <InputForm
                                    label={"名(カナ)"}
                                    type={"text"}
                                    style={isWideTablet ? styles.label2 : styles.label}
                                    class={`representNameKana${index + 1}`}
                                    id={`representNameKana${index + 1}`}
                                    maxLength={"50"}
                                    value={inputPlayer.length !== 0 ? inputPlayer[index][0].nameKana : ""}
                                    placeholder={""}
                                    disabled={disabled}
                                />
                            </div>
                            <div>
                                <Label style={styles.label3} label={"性別"} />
                                <PullDown 
                                    selectedValue={inputPlayer.length !== 0 ? inputPlayer[index][0].gender : "0"} 
                                    selectStyle={styles.check} data={gender} 
                                    class={`represent_gender_type${index + 1}`} 
                                    id={`represent_gender_type${index + 1}`} 
                                />
                            </div>
                            <Line style={isWideTablet ? styles.line2 : styles.line}></Line>
                        </div>
                        {[...Array(data.playerCount - 1).keys()].map((data) => (
                            <div style={isWideTablet ? styles.form2 : styles.form}>
                                <div style={{marginBottom: "20px"}}>
                                    <Label label={`利用者${data + 2}`} style={styles.title} />
                                    <BlackCheckBox 
                                        id={`${index + 1}${data}`} 
                                        className={"undecidedChecked"}
                                        onChange={onChangeInactive} 
                                        defaultChecked={inputPlayer.length !== 0 && inputPlayer[index][data + 1] !== undefined ? inputPlayer[index][data + 1].undecided : false} 
                                        item={"未定"} 
                                        checkAreaStyle={{color: "#6f6f6f", fontSize: "small", letterSpacing: "0.2rem"}} />
                                </div>
                                <div style={{display: "flex"}}>
                                    <InputForm
                                        label={"姓(漢字)"}
                                        type={"text"}
                                        style={isWideTablet ? styles.label2 : styles.label}
                                        id={`accompanySurnameKanji${index + 1}${data}`}
                                        class={`accompanySurnameKanji${index + 1}`}
                                        maxLength={"50"}
                                        value={inputPlayer.length !== 0 && inputPlayer[index][data + 1] !== undefined ? inputPlayer[index][data + 1].familyName : ""}
                                        placeholder={""}
                                        disabled={disabled}
                                    />
                                    <InputForm
                                        label={"名(漢字)"}
                                        type={"text"}
                                        style={isWideTablet ? styles.label2 : styles.label}
                                        id={`accompanyNameKanji${index + 1}${data}`}
                                        class={`accompanyNameKanji${index + 1}`}
                                        maxLength={"50"}
                                        value={inputPlayer.length !== 0 && inputPlayer[index][data + 1] !== undefined ? inputPlayer[index][data + 1].name : ""}
                                        placeholder={""}
                                        disabled={disabled}
                                    />
                                </div>
                                <div style={{display: "flex"}}>
                                    <InputForm
                                        label={"姓(カナ)"}
                                        type={"text"}
                                        style={isWideTablet ? styles.label2 : styles.label}
                                        id={`accompanySurnameKana${index + 1}${data}`}
                                        class={`accompanySurnameKana${index + 1}`}
                                        maxLength={"50"}
                                        placeholder={""}
                                        value={inputPlayer.length !== 0 && inputPlayer[index][data + 1] !== undefined ? inputPlayer[index][data + 1].familyNameKana : ""}
                                        disabled={disabled}
                                    />
                                    <InputForm
                                        label={"名(カナ)"}
                                        type={"text"}
                                        style={isWideTablet ? styles.label2 : styles.label}
                                        id={`accompanyNameKana${index + 1}${data}`}
                                        class={`accompanyNameKana${index + 1}`}
                                        maxLength={"50"}
                                        placeholder={""}
                                        value={inputPlayer.length !== 0 && inputPlayer[index][data + 1] !== undefined ? inputPlayer[index][data + 1].nameKana : ""}
                                        disabled={disabled}
                                    />
                                </div>
                                <div>
                                    <Label style={styles.label3} label={"性別"} />
                                    <PullDown selectedValue={inputPlayer.length !== 0 && inputPlayer[index][data + 1] !== undefined ? inputPlayer[index][data + 1].gender : "0"} 
                                        selectStyle={styles.check} 
                                        data={gender} 
                                        id={`gender_type${index + 1}${data}`} 
                                        class={`gender_type${index + 1}`} />
                                </div>
                                <Line style={isWideTablet ? styles.line2 : styles.line}></Line>
                            </div>
                        ))}
                        
                    </>
                ))}
                <div style={styles.box}>
                    <Button buttonText="戻 る" className={isWideTablet ? "backBtnSp" : "backBtnPc"} onClick={onClickBack} />
                    <Button buttonText="確認画面へ" className={isWideTablet ? "useBtnSp" : "useBtnPc"} onClick={determination} />
                </div>
                <Link style={styles.reservelink} to="/reserve/golf/search" >ゴルフ検索TOPに戻る</Link>
            </div>
            <div style={styles.footer}>
                <GolfFooterContainer />
            </div>
        </div >

    )
}

const styles = {
    heading: {
        fontSize: "1.5rem",
        backgroundColor: "rgb(111, 111, 111)",
        width: "100%",
        height: "60px",
        display: "flex",
        justifyContent: "space-around",
        marginBottom: "50px",
        color: "white",
    },
    headingText: {
        lineHeight: "60px",
        display: "inline-block",
        margin: "0px",
    },
    top: {
        width: "100%",
        paddingTop: "25px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    base: {
        background: "rgba(245,245,245,0.94)",
        marginRight: "auto",
        marginLeft: "auto",
        width: "70%",
    },
    base2: {
        background: "rgba(245,245,245,0.94)",
        marginRight: "auto",
        marginLeft: "auto",
        width: "90%",
    },
    planInfoArea: {
        marginRight: "auto",
        marginLeft: "auto",
        width: "70%",
        background:"rgba(245, 245, 245, 0.94)",
        padding:"5px 0px"
    },
    planInfoAreaSp: {
        marginRight: "auto",
        marginLeft: "auto",
        width: "90%",
        background:"rgba(245, 245, 245, 0.94)",
        padding:"5px 0px"
    },
    planInfoBody:{
        fontSize: "small",
        color: "rgb(111, 111, 111)",
        fontWeight: "700",
        margin: "0px 0px 0px 20%"
    },
    planInfoBodySp:{
        fontSize: "small",
        color: "rgb(111, 111, 111)",
        fontWeight: "700",
        width: "90%",
        marginLeft: "auto",
        marginRight: "auto",
    },
    box: {
        display: "inline-block",
        textAlign: "center",
        margin: "50px auto",
        width: "100%",
    },
    title: {
        fontSize: "1rem",
        fontWeight: "bold",
        marginBottom: "25px",
    },
    linkList: {
        //display: "table",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    reservelink: {
        display: "block",
        padding: "3px",
        color: "#6f6f6f",
        textAlign: "center",
        padding: "0px 0px 50px",
        fontSize: "small",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        marginLeft: "20%",
        marginBottom: "50px",
    },
    breadCrumb2: {
        display: "none",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    label: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: "small",
        letterSpacing: "0.2rem"
    },
    label2: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: 12.6,
        letterSpacing: "0.2rem"
    },
    label3: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: "small",
        letterSpacing: "0.2rem",
        marginLeft: "5px"
    },
    image: {
        width: 200,
        width: "40%",
        margin: "0 auto",
    },
    form: {
        width: "60%",
        margin: "0px auto 50px",
    },
    form2: {
        width: "90%",
        margin: "0px auto 30px",
    },
    line: {
        width: "100%",
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
        margin: "45px auto 0px",
    },
    line2: {
        width: "100%",
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
        margin: "25px auto 0px",
    },
    footer: {
        color: "#ffffff",
        marginTop: "100px",
    },
    check: {
        padding: "8px",
        marginLeft: "5px",
        width: "110px",
        webkitAppearance: "none",
        mozAppearance: "none",
        appearance: "none",
        backgroundImage: `url(${img_pull})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: "right 10px center",
        cursor: "pointer",
        border: "solid 1px #b7b7b7",
        marginBottom: "1rem",
        fontSize: "1rem",
    },
    bikou: {
        resize: "none",
        borderWidth: 1.5,
        marginLeft: "5px",
        width: "calc(100% - 30px)",
        border: "solid 1px #b7b7b7",
        padding: "5px 10px",
        letterSpacing: 3,
        fontSize: 17,
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
    },
}

const mapStateToProps = (state) => {
    return {
        inputPlayer: state.inputPlayer,
        teeTimeList: state.teeTimeList,
        reserver: state.reserver,
        changeReserveNo : state.changeReserveNo,
        login: state.login,
        reserveCheckInfo:state.reserveCheckInfo,
        kaiinken:state.kaiinken,
        course: state.course,
        plan: state.plan,
        facility:state.facility,
        golfLocation:state.golfLocation
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        addInputPlayer: (item) => {
            dispatch({ type: "ADD_INPUT_PLAYER_INFO", payload: { inputPlayerInfo: item} })
        },
        addTeeTimeList: (item) => {
            dispatch({ type: "ADD_TEETIME_LIST", payload: { teeTimeList: item } })
        },
        addReserver: (item) => {
            dispatch({ type: "ADD_RESERVER", payload: { reserver: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(GolfInputContainer);
